export const normalizeArrayOfObjectsIntoSingleObject = (arrayOfObjects) => {
    let finalObj = [];

    arrayOfObjects?.map((value) => {
        return {[value?.name]: value?.count}
    }).forEach((val) => {
        Object?.assign(finalObj, val);
    });

    return finalObj;
}

export const arrayUtils = (arrayOfData = []) => {
    let arr = arrayOfData;

    return {
        accumulateNumberValues: function (startingValue = 0) {
            arr = arr.reduce((acc, currVal) => acc + currVal, startingValue);
            return this;
        },
        // accumulateObjectValues: function (startingValue) {
        //     arr = arr.reduce((acc, currVal) => {
        //         if(currVal === Object) {
        //             return {
        //                 ...acc,
        //                 ...currVal
        //             }
        //         }
        //         return acc;
        //
        //     }, startingValue);
        //     return this;
        // },
        combineArrays: function (newArray) {
            arr = [...arr, ...newArray];
            return this;
        },
        removeDuplicatesInTheArray: function () {
            arr = [...new Set(arr)];
            return this;
        },
        filterOutValueFromArray: function (value) {
            arr = arr?.filter(v => v !== value);
            return this;
        },
        filterOutOtherValuesFromArray: function (value) {
            arr = arr?.filter(v => v === value);
            return this;
        },
        filterOutValuesFromAnotherArray: function (newArray) {
            arr = arr?.filter(t => !newArray?.includes(t));
            return this;
        },
        doesArrayContainDuplicates: function () {
            const newArr = [...new Set(arr)];
            return newArr?.length !== arr?.length;
        },
        returnValuesIfAny: function () {
            // for semantic purposes
            return arr?.length !== 0 && arr !== undefined ? arr : [];
        },
        get: function () {
            // only use this if you know a value is defined
            return arr;
        }
    }
}